<template>
  <ValidationProvider
    v-slot="{ errors }"
    :bails="provider.Bails"
    :class="provider.Class"
    :immediate="provider.Immediate"
    :name="catalog[field].Label"
    :rules="validationRules"
    :tag="provider.Tag"
    :vid="vid"
  >
    {{ updateErrors(errors) }}
    <b-field :type="{ 'is-danger': errors[0] }">
      <template v-if="!errorOff" #message>
        <kst-list hide-empty :items="getErrors(errors)"/>
      </template>

      <slot name="left" />

      <b-switch
        v-model="data[field]"
        class="ks-display-block has-left-label"
        :disabled="theDisabled"
        :id="vid"
        @input="handleInput"
      >
        <span class="pt-1 is-size-7 has-text-centered">{{ theText }}</span>
      </b-switch>

      <slot name="right" />
    </b-field>
  </ValidationProvider>
</template>

<script>
import OutputType from "@/services/Input/OutputType.js";
import OutputTypeEnum from "@/services/Input/OutputTypeEnum.js";

export default {
  props: {
    field: {
      type: String,
      required: true 
    },
    data: {
      type: Object,
      required: true
    },
    catalog: {
      type: Object,
      required: true
    },
    disabled: Boolean,
    errorOff: Boolean,
    loadOnFocus: Boolean,
    vid: String,
    validationRules: {
      type: Object
    },
    // catalog
    provider: Object
  },
  computed: {
    maxlength() {
      if (this.catalog[this.field].Length !== undefined) {
        return this.catalog[this.field].Length;
      }
      else if (this.catalog[this.field].MaxLength !== undefined) {
        return this.catalog[this.field].MaxLength;
      }

      return undefined;
    },
    theDisabled() {
      return this.getDisabled();
    },
    theText() {
      return this.getText();
    }
  },
  mounted() {
    if (this.loadOnFocus) {
      this.focus();
    }
  },
  methods: {
    focus() {
      // cannot receive focus
    },

    handleInput() {
      this.$emit(this.$kst.Enum.Event.Input);
    },
    updateErrors(errors) {
      this.$emit(this.$kst.Enum.Event.Error, errors);
    },

    getDisabled() {
      if (this.disabled === undefined) {
        return this.catalog[this.field].ReadOnly;
      }
      return this.disabled;
    },
    getErrors(errors) {
      let result = [];

      for (const error of errors) {
        if (error !== this.$kst.Vee.ValidRule) {
          result.push(error);
        }
      }

      return result;
    },
    getText() {
      let output = this.catalog[this.field].Output;
      let value = this.data[this.field];

      if (output !== undefined) {
        switch (output) {
          case OutputTypeEnum.ActiveInactive:
            return this.$kst.Format.getActiveInactive(value);
          case OutputTypeEnum.AutoManual:
            return this.$kst.Format.getAutoManual(value);
          case OutputTypeEnum.Boolean:
            return this.$kst.Format.getBoolean(value);
          case OutputTypeEnum.DefaultNonDefault:
            return this.$kst.Format.getDefaultNonDefault(value);
          case OutputTypeEnum.OpenClosed:
            return this.$kst.Format.getOpenClosed(value);
          case OutputTypeEnum.YesNo:
            return this.$kst.Format.getYesNo(value);
        }
      }

      const type = this.catalog[this.field].Type;
      return OutputType[type].Default;
    }
  }
}
</script>